
import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios';
import { TailSpin } from 'react-loader-spinner'
import LeatestProduct from './LeatestProduct';

function Products() {
    const [data, setData] = useState([]);
    const [filter, setFilter] = useState(data);
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)

            const response = await axios.get("https://fakestoreapi.com/products/")
            const revItem = response.data.reverse()
            setData(revItem)
            setLoading(false)

        }
        fetchData()
    }, []);

    const Loading = () => {
        return (

            < >
                <div className='d-flex justify-content-center'>
                    <TailSpin
                        height="60"
                        width="60"
                        radius="9"
                        color="black"
                        ariaLabel="loading"
                        wrapperStyle
                        wrapperClass
                    />
                </div>

                fetching...

            </>
        );
    }
    const filterProduct = (cat) => {
        const updateList = data.filter((x) => x.category === cat);
        setFilter(updateList);
    }

    const ShowProduct = () => {
        return (
            <div>
                <h1 className='fw-bolder mt-5 text-center'> CHOOSE YOUR CHOICES</h1>
                <hr />
                <div className="buttons d-flex justify-content-center flex-wrap mb-5 pb-5 ">

                    <div className="btn btn-outline-dark m-2 " onClick={() => setFilter(data)}>All</div>
                    <div className="btn btn-outline-dark m-2" onClick={() => filterProduct("men's clothing")}>Men's clothing</div>
                    <div className="btn btn-outline-dark m-2" onClick={() => filterProduct("women's clothing")}>Women's clothing</div>
                    <div className="btn btn-outline-dark m-2" onClick={() => filterProduct("jewelery")}>Jewelary</div>
                    <div className="btn btn-outline-dark m-2" onClick={() => filterProduct("electronics")}>electronic</div>
                </div>

                <div className="row">
                    {filter.map((products) => {

                        return (
                            <>

                                <div className="col col-sm-6 col-md-4 col-lg-3 col-xl-2  mb-4">
                                    <div className="card h-60  text-center p-2" key={products.id}>
                                        <img src={products.image} className="card-img-top" alt={products.title} height='200px' />
                                        <div className="card-body">
                                            <h5 className="card-title mb-0">{products.title.substring(0, 12)}</h5>
                                            <p className="card-text fw-bolder">₹{products.price}</p>
                                            <Link to={`/productDet/${products.id}`} className="btn btn-outline-dark m-0 ">BUY</Link>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )
                    })}
                </div>
            </div>
        );
    };



    return (
        <div>
            <div className='container-fluid  px-5 bg-light'>
                {loading ? <Loading /> : <LeatestProduct data={data} key={data._id} />}
            </div>

            <div className="container-fluid ">

                {loading ? <Loading /> : <ShowProduct />}
            </div>

        </div>
    )
}

export default Products
